/** Pure shaping for the Bill Scraping page. Kept out of the component: no jsdom here, so a render test cannot run. */

/** Hours after which a run's numbers are no longer current. */
export const STALE_AFTER_HOURS = 36;
export const PROVIDER_STATUS = {
  OK: 'ok',
  NO_BILLS: 'no-bills',
  SKIPPED: 'skipped-all',
  ERROR: 'error'
};

/** `skipped-all` is HEALTHY - nothing was due, the anti-hammer working. Not the same as `no-bills`. */
export const isProviderHealthy = provider => (provider === null || provider === void 0 ? void 0 : provider.status) === PROVIDER_STATUS.OK || (provider === null || provider === void 0 ? void 0 : provider.status) === PROVIDER_STATUS.SKIPPED;

/** Worst first. `action_required` outranks all: true only for credential_failure and mfa_required, the two a person can fix. */
export const sortProviders = providers => [...(providers || [])].sort((a, b) => {
  if (!!b.action_required !== !!a.action_required) return b.action_required ? 1 : -1;
  if (isProviderHealthy(a) !== isProviderHealthy(b)) return isProviderHealthy(a) ? 1 : -1;
  return (b.downloaded || 0) - (a.downloaded || 0);
});

/** One point per run for the bills-by-date chart, oldest first so the x axis reads left to right. */
export const toDateSeries = runs => [...(runs || [])].filter(run => run === null || run === void 0 ? void 0 : run.finished_at).sort((a, b) => String(a.finished_at).localeCompare(String(b.finished_at))).map(run => {
  var _run$totals, _run$totals2;
  return {
    date: String(run.finished_at).slice(0, 10),
    downloaded: ((_run$totals = run.totals) === null || _run$totals === void 0 ? void 0 : _run$totals.pdfs) || 0,
    uploaded: ((_run$totals2 = run.totals) === null || _run$totals2 === void 0 ? void 0 : _run$totals2.s3_uploaded) || 0
  };
});

/** Newest run old enough that showing its numbers as current would mislead. */
export const isStale = function (runs) {
  let now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  const newest = (runs || []).find(run => run === null || run === void 0 ? void 0 : run.finished_at);
  if (!newest) return false; // no data at all is a different message, not staleness
  const finished = Date.parse(newest.finished_at);
  if (Number.isNaN(finished)) return false;
  return now - finished > STALE_AFTER_HOURS * 60 * 60 * 1000;
};

/** Ingest funnel. `posted` is the number that matters: S3 is the means, the app is the end. */
export const ingestSummary = run => {
  const ingest = (run === null || run === void 0 ? void 0 : run.ingest) || {};
  const streams = ingest.streams || 0;
  return {
    streams,
    dated: ingest.dated || 0,
    mapped: ingest.mapped || 0,
    pending: ingest.pending || 0,
    posted: ingest.posted || 0,
    mappedPercent: streams ? Math.round((ingest.mapped || 0) / streams * 100) : 0
  };
};